import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 2,
  id: "subapp-container"
}

import { useRoute } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(['main', _unref(route).path.startsWith('/console/') && 'main-center', `${_unref(route)?.name}-wrap`])
  }, [
    (_unref(route).meta?.showMenu)
      ? _renderSlot(_ctx.$slots, "side", { key: 0 })
      : _createCommentVNode("", true),
    (_unref(route).path.startsWith('/console/'))
      ? _renderSlot(_ctx.$slots, "default", { key: 1 })
      : (_openBlock(), _createElementBlock("div", _hoisted_1))
  ], 2))
}
}

})